module.exports = __webpack_public_path__ + "img/hotelFamily-6.ae785f4a.jpg";